export enum TestVariantNames {
  DEFAULT = "DEFAULT",
  FLIRTY = "FLIRTY",
  FLIRTY_WITH_STREAMERS = "FLIRTY_WITH_STREAMERS",
  NON_FLIRTY = "NON_FLIRTY",
  NONE = "NONE",
}
